const Views = self => ({
    get time() {
        return parseInt(Date.now() / 1000, 0) - self.timestamp;
    },
});
export default Views;
